<app-top-menu></app-top-menu>

<div id="scroll_top" (click)="scrollTop()">

</div>